// extracted by mini-css-extract-plugin
module.exports = {"container":"Stage_container__o3IM5"};